import { createTrackingUtils } from "../index";
import useGlobalContext from "../../../hooks/useGlobalContext";
import { localizationUtils } from "@flights/web-api-utils-universal";

const utils = createTrackingUtils({
  name: "flights_web_filters_width_desktop",
  stages: {
    desktop_sr: 1,
    ltr: 2,
    rtl: 3
  },
  defaultStage: 1,
  goals: {}
});

export const useTrackReducedFiltersWidth = () => {
  const { stages } = utils;
  const { lang } = useGlobalContext();
  lang && localizationUtils.isRTL(lang) ? stages.rtl() : stages.ltr();
};

export default utils;
